import { Form, Row, Col, Button } from 'react-bootstrap'
import { useState, useEffect } from 'react'
import { Request } from '@group-devs/yfp7-global-modules'
import Alert from '@group-devs/yfp7-global-modules/components/Alert'

const request = new Request(process.env.apiDomain)

function LoginDetails(props) {

    let contactAccount = props.contactAccount
    const [showUpdate, setShowUpdate] = useState(false);
    const [readOnly, setReadOnly] = useState(true);
    const [contactId, setContactId] = useState(null);

    const [successMessage, setSuccessMessage] = useState('');
    const [errorMessage, setErrorMessage] = useState('');
    const [key, setKey] = useState(0);

    const [data, setData] = useState({ 
        email: null,
        password:null
    })

    const onClickEdit = () => {
        setShowUpdate(!showUpdate)
        setReadOnly(false)
    }

    const onClickCancel = () => {
        setShowUpdate(!showUpdate)
        setReadOnly(true)
    }

    function handleChange(evt)
    {
        const value = evt.target.value;
        setData({
          ...data,
          [evt.target.name]: value
        });
    }

    async function handleSave(e)
    {
        let res = await request.contacts.updateLoginDetails({...data, contact_id: contactId});
        if(res.err){
            console.log('error')
        }else{
            onSuccess('Successfully updated login details.')
            onClickCancel()
        }
    }

    const onSuccess = (message) => 
    {
        setSuccessMessage(message);
        setErrorMessage(''); // Clear error message if any
        setKey(prevKey => prevKey + 1); // Change key to force re-render
    }

    useEffect(() => {
        if(typeof contactAccount != 'undefined'){
            setData({ 
                email: contactAccount ? contactAccount.contact.email : "",
            })

            setContactId(contactAccount.contact_id)
        }
    }, [contactAccount]);
    
    return (
        <div className="loginDetails py-5 border-bottom">
            <Row>
                <Col xl={{span:10, offset:1}}>
                    <Alert key={key} successMessage={successMessage} errorMessage={errorMessage}/>
                    <p><strong>Login Details</strong></p>
                    <Form>
                        <Form.Group as={Row} controlId="formPlaintextEmail">
                            <Form.Label column md="3" className="text-md-right">Login Email:</Form.Label>
                            <Col md="7">
                                <Form.Control type="email" className="rounded-0"  name="email" onChange={handleChange} value={data.email} readOnly={readOnly}/>
                            </Col>
                        </Form.Group>
                        <Form.Group as={Row} controlId="formPlaintextPassword">
                            <Form.Label column md="3" className="text-md-right">Password:</Form.Label>
                            <Col md="7">
                                <Form.Control type="password" className="rounded-0 mb-4"  name="password" onChange={handleChange} placeholder="******"  readOnly={readOnly}/>
                                {!showUpdate && <Button onClick={onClickEdit} className="px-5 py-2 mb-2 btn btn-success rounded-pill"><strong>Edit</strong></Button>}
                                {showUpdate && 
                                    <>
                                        <Button className="px-5 py-2 mr-2 mb-2 btn btn-success rounded-pill" onClick={handleSave}><strong>Save</strong></Button> 
                                        <Button onClick={onClickCancel} className="px-5 py-2 mb-2 btn btn-secondary rounded-pill"><strong>Cancel</strong></Button> 
                                    </>
                                }                        
                            </Col>
                        </Form.Group>
                    </Form>
                </Col>
            </Row>
        </div>
    )
}

export default LoginDetails
